var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAggregate01 = function SvgAggregate01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aggregate-01_svg2__a",
    x1: 20.77,
    x2: 182.66,
    y1: 178.45,
    y2: 36.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M175.39 97.59c-11.72 0-21.51 8.39-23.69 19.48h-10.98c-19.88 0-36.05-16.17-36.05-36.06V17.16l21.13 24.33a4.67 4.67 0 0 0 3.53 1.61c1.08 0 2.18-.38 3.06-1.14 1.95-1.69 2.15-4.64.46-6.59L103.53 1.61s-.08-.07-.11-.11l-.24-.24c-.04-.04-.07-.08-.11-.12-.04-.03-.08-.05-.12-.08-.07-.06-.15-.12-.23-.18-.09-.06-.18-.12-.28-.18-.09-.06-.18-.11-.27-.16-.08-.04-.15-.08-.23-.11-.1-.05-.2-.08-.3-.12s-.21-.08-.31-.11l-.24-.06-.31-.06c-.1-.02-.21-.04-.32-.05-.1 0-.19-.01-.29-.01-.05 0-.1-.02-.16-.02s-.1.01-.16.02c-.1 0-.19 0-.29.01-.11.01-.21.03-.32.05s-.21.04-.31.06l-.24.06c-.11.03-.21.07-.31.11l-.3.12c-.08.04-.16.07-.23.11-.09.05-.18.11-.27.16-.09.06-.19.12-.28.18-.08.06-.15.11-.23.18-.04.03-.08.05-.12.08-.04.04-.07.08-.11.12l-.24.24c-.04.04-.08.07-.11.11L67.17 35.37a4.68 4.68 0 0 0 .46 6.59 4.62 4.62 0 0 0 3.06 1.14c1.31 0 2.6-.54 3.53-1.61l21.13-24.33v63.85c0 19.88-16.17 36.06-36.05 36.06H48.32c-2.18-11.09-11.97-19.48-23.69-19.48-13.32 0-24.15 10.83-24.15 24.15s10.83 24.15 24.15 24.15c11.72 0 21.51-8.39 23.69-19.48H59.3c14.68 0 27.75-7.01 36.05-17.86v43.61c-11.09 2.18-19.48 11.97-19.48 23.69 0 13.32 10.83 24.15 24.15 24.15s24.15-10.83 24.15-24.15c0-11.72-8.39-21.51-19.48-23.69v-43.61c8.3 10.85 21.37 17.86 36.05 17.86h10.98c2.18 11.09 11.97 19.48 23.69 19.48 13.32 0 24.15-10.83 24.15-24.15s-10.83-24.15-24.15-24.15ZM24.61 136.55c-8.17 0-14.81-6.64-14.81-14.81s6.64-14.82 14.81-14.82 14.81 6.65 14.81 14.81-6.65 14.81-14.81 14.81Zm90.2 39.3c0 8.17-6.64 14.81-14.81 14.81s-14.81-6.65-14.81-14.81 6.64-14.81 14.81-14.81 14.81 6.65 14.81 14.81m60.58-39.3c-8.17 0-14.81-6.64-14.81-14.81s6.64-14.81 14.81-14.81 14.81 6.65 14.81 14.81-6.64 14.81-14.81 14.81",
    style: {
      fill: "url(#aggregate-01_svg2__a)"
    }
  }));
};
export default SvgAggregate01;